import { TOrigin } from "../../@types/ConfigType";

const ENVIRONMENTS = ["prod", "hml", "dev"];

export const getEnvironmentFromUrl = (
  defaultValue: string | null | undefined,
) => {
  const env =
    window.location.origin.split(/:\/\/|\.|\/|:/)[1].split("-")[1] ||
    defaultValue;

  if (!env) return undefined;
  return (ENVIRONMENTS.includes(env) ? env : "hml") as "prod" | "hml" | "dev";
};

export const ORIGIN_HEADER = "X-Origem";

const ORIGIN_HEADER_VALUES: Record<TOrigin, string> = {
  [TOrigin.External]: "portal-professor",
  [TOrigin.Painel]: "painel",
};

export const getOriginFromUrl = (value: string | null | undefined): TOrigin =>
  value?.trim().toLowerCase() === "painel" ? TOrigin.Painel : TOrigin.External;

export const originToHeaderValue = (origin: TOrigin): string =>
  ORIGIN_HEADER_VALUES[origin] ?? ORIGIN_HEADER_VALUES[TOrigin.External];
